import { TeamMember } from "../types/TeamMember"

export function getTeamMemberDisplayName(teamMember: Pick<TeamMember, "user">) {
  return teamMember.user?.name || teamMember.user?.email || "Unknown User"
}
